import { render, staticRenderFns } from "./ReferralInfo.vue?vue&type=template&id=d7e62052&scoped=true&lang=pug&"
import script from "./ReferralInfo.vue?vue&type=script&lang=js&"
export * from "./ReferralInfo.vue?vue&type=script&lang=js&"
import style0 from "./ReferralInfo.vue?vue&type=style&index=0&id=d7e62052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7e62052",
  null
  
)

/* custom blocks */
import block0 from "./ReferralInfo.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VRow,VTextField})
